import "url-search-params-polyfill";
import React, { Suspense, lazy } from "react";
import { createRoot } from "react-dom/client";
import UIkit from "uikit";
import "react-app-polyfill/ie11";
import Icons from "uikit/dist/js/uikit-icons";
import { BrowserRouter as Router } from "react-router-dom";
import "fullscreen-polyfill";
import injectScript, { lowPriorityScripts } from "./script-loader";

UIkit.use(Icons);

const { REACT_APP_MOBILE } = process.env;

let basePath;
if (REACT_APP_MOBILE) {
  basePath = "./";
} else {
  basePath = "/";
}

const scripts = [
  "polyfill.js",
  "synaren-online.js",
  "config.js",
  "random-seed.js",
];

if (!window.location.origin.includes("localhost")) {
  scripts.push("synaren-graphics-engine.js");
}
const loaded = scripts.map((script) => injectScript(`${basePath}${script}`));

if (window.location.origin.includes("localhost")) {
  loaded.push(injectScript("http://localhost:3030/synaren-graphics-engine.js"));
}

const lowPriority = ["uikit-icons.min.js", "uikit.min.js"];
lowPriority.forEach((script) => lowPriorityScripts(`${basePath}${script}`));

if (!window.location.origin.includes("localhost") && !REACT_APP_MOBILE) {
  lowPriorityScripts("https://synaren-app.com/public-shared/track.js");
}

const AppComponent = REACT_APP_MOBILE
  ? lazy(() => import("./AppMobile"))
  : lazy(() => import("./App"));

const root = createRoot(document.getElementById("root"));

loaded[loaded.length - 1].then(() => {
  root.render(
    <Router>
      <Suspense fallback={<div></div>}>
        <AppComponent />
      </Suspense>
    </Router>
  );
});
